import { helpers } from 'vuelidate/lib/validators';

// Value must be format HH:MM
export const mustBeDuration = helpers.regex('mustBeDuration', /^\d{2}:\d{2}$/);
